<template lang="pug" src="./moderation.pug"> </template>
<style lang="scss" src="./moderation.scss" scoped> </style>

<script>

import { mapState } from 'vuex'
import scroll from '@/utils/scroll'

export default {
    data: () => ({
        dateModal: null,
        resetAccountFeeDate: null,
        resetAccountFeeDialog: false,
        filters: {},
        sorting: {}
    }),
    computed: {
        ...mapState({
            requests: (state) => state.moderation.requests,
            isTableLoad: (state) => state.moderation.isLoaded,
            pagination: (state) => state.moderation.pagination,
            appliedFilters: (state) => state.moderation.filters,
            resetAccountFee: (state) => state.moderation.resetAccountFeeDate
        }),
        statuses: function() {
            return ['filling', 'check', 'cancelled', 'success'].map(it => ({
                text: this.$vuetify.t(`$vuetify.pages.Moderation.statuses.${it}`),
                value: it
            }))
        },
        types: function() {
            return ['admin', 'leader', 'business'].map(it => ({
                text: this.$vuetify.t(`$vuetify.pages.CreateAccounts.selects.${it}`),
                value: it
            }))
        },
        headers() {
            return [
                { text: '№', sortable: false, number: true },
                { text: 'type', value: '"type"' },
                { text: 'firstName', value: '"firstName"' },
                { text: 'lastName', value: '"lastName"' },
                { text: 'email', value: '"email"' },
                { text: 'phoneNumber', value: '"phoneNumber"' },
                { text: 'cardNumber', value: '"cardNumber"' },
                { text: 'taxId', value: '"taxId"' },
                { text: 'passportNumber', value: '"passportNumber"' },
                { text: 'status', value: '"status"' },
                { text: 'createdAt', value: '"createdAt"' }
            ]
                .map(it => Object.assign(it, {
                    text: it.number ? it.text : this.$vuetify.lang.t(`$vuetify.pages.Moderation.table.${it.text}`)
                }))
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getRequestsByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getRequestsByPage(this.pagination.page)
        this.$store.dispatch('moderation/getResetAccountFeeDate').then(() => {
            this.resetAccountFeeDate = this.resetAccountFee
        })
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('moderation/SET_PAGINATION', { page: 1, length: null })
        next()
    },
    methods: {
        changeDate(date) {
            this.resetAccountFeeDate = date
        },
        changeDateModal() {
            this.dateModal = false
        },
        reset() {
            this.filters = Object.assign({}, {
                status: null,
                type: null,
                email: null
            })
            this.$store.commit('moderation/RESET_REQUESTS')
            this.getRequestsByPage()
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getRequestsByPage(page, true)
            }
        },
        getRequestsByPage(page = 1, isScrollEnable = false) {
            this.$store.dispatch('moderation/getRequests', {
                page,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        submit() {
            this.$store.commit('moderation/SET_FILTERS', Object.assign({}, this.filters))
            this.getRequestsByPage()
        },
        async resetFee() {
            if (!this.resetAccountFeeDate) {
                const res = await this.$store.dispatch('moderation/deleteResetAccountFeeDate', {})
                if (res) {
                    this.resetAccountFeeDialog = !this.resetAccountFeeDialog
                }
                return
            }

            const res = await this.$store.dispatch('moderation/changeResetAccountFeeDate', {
                date: this.resetAccountFeeDate
            })

            if (res) {
                this.resetAccountFeeDialog = !this.resetAccountFeeDialog
            }
        },
        async changeStatus(status, oldStatus, id, index) {
            const res = await this.$store.dispatch('moderation/changeStatus', { id, status })

            this.$nextTick(() => {
                this.$store.commit('moderation/UPDATE_STATUS', {
                    index, status, old: !!res, oldStatus
                })
            })
        },
        displayChangeStatus(item) {
            const requiredProps = [
                'email', 'phoneNumber', 'cardNumber', 'taxId',
                'passportNumber', 'firstName', 'lastName'
            ]

            return !requiredProps.some(it => !item[it])
        }
    }
}
</script>
